// extracted by mini-css-extract-plugin
module.exports = {"roid10":"roid10-module--roid10--1867D","item":"roid10-module--item--2Lg-S","row":"roid10-module--row--nuq5g"};